import React, {memo} from 'react';

import styles from './title.module.scss';

export const Title = memo(({children}) => {
	return (
		<>
			<h2 className={styles.title}>{children}</h2>
		</>
	);
});
